import LocalStorageManager from 'zoomforth_zfutils/localstorage_manager.js';

let localStorage;

const init = function({ namespace, userId }) {
  localStorage = new LocalStorageManager({ namespace, userId });
};

const get = function() {
  if (!localStorage) {
    throw new Error('You must call `init` on `localStorage` appglobal before calling `get`');
  }
  return localStorage;
};

export { init, get };

export default { init, get };
